import { render, staticRenderFns } from "./VdTips.vue?vue&type=template&id=8158eba6&"
import script from "./VdTips.vue?vue&type=script&lang=js&"
export * from "./VdTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports